// Uklad mapy podrozy: trasy na wezacej sie sciezce od dolu ekranu w gore.
//
// Pozycje liczymy jako PROCENTY kontenera (x od lewej, y od gory), dzieki czemu ten
// sam uklad dziala i na telefonie, i na desktopie - bez pomiaru DOM. Czysta funkcja,
// wiec latwo ja przetestowac i nie ma tu ani Canvasu, ani Plancka.

export interface MapPoint {
  /** Indeks trasy w rejestrze (0 = pierwsza, start podrozy). */
  index: number;
  /** Pozycja X w procentach szerokosci kontenera (0..100). */
  xPct: number;
  /** Pozycja Y w procentach wysokosci kontenera (0 = gora, 100 = dol). */
  yPct: number;
}

/** Zapas od krawedzi (%), zeby kola z podpisami nie byly obcinane. */
const MARGIN_PCT = 9;
/** Maksymalne wychylenie na boki od srodka (%). */
const SWING_PCT = 21;
/** Co czwarta trasa wraca na srodowisko - daje ksztalt weza, nie linii prostej. */
const SWING_PATTERN = [0, 1, 0, -1];

/** Rozmieszcza `count` tras od dolu (indeks 0) do gory kontenera. */
export function layoutMap(count: number): MapPoint[] {
  if (count <= 0) return [];
  const span = 100 - 2 * MARGIN_PCT;
  const step = count === 1 ? 0 : span / (count - 1);
  const points: MapPoint[] = [];
  for (let index = 0; index < count; index += 1) {
    const swing = SWING_PATTERN[index % SWING_PATTERN.length] ?? 0;
    points.push({
      index,
      xPct: 50 + swing * SWING_PCT,
      // Indeks 0 na dole, ostatni na gorze - podroz wspina sie po mapie.
      yPct: 100 - MARGIN_PCT - index * step,
    });
  }
  return points;
}

function fmt(value: number): number {
  return Number(value.toFixed(2));
}

/**
 * Sciezka SVG (viewBox 0 0 100 100) przechodzaca DOKLADNIE przez srodki tras.
 *
 * Uzywamy splajnu Catmull-Roma zamienionego na krzywe Beziera: droga jest
 * gladka, ale nie "ucieka" od wezlow. Wczesniej zaokraglenie (kontrolka = wezel,
 * koniec = srodek odcinka) omijalo punkty - linia przecinala zakrety obok kol.
 */
export function mapPath(points: readonly MapPoint[]): string {
  const first = points[0];
  if (!first) return '';
  if (points.length === 1) return `M ${fmt(first.xPct)} ${fmt(first.yPct)}`;

  const parts = [`M ${fmt(first.xPct)} ${fmt(first.yPct)}`];
  for (let index = 0; index < points.length - 1; index += 1) {
    const current = points[index];
    const next = points[index + 1];
    if (!current || !next) break;

    const previous = points[index - 1] ?? first;
    const after = points[index + 2] ?? next;

    // Catmull-Rom -> Bezier: styczne bierzemy z sasiadow, wiec krzywa trafia
    // dokladnie w `current` i `next`.
    const c1x = current.xPct + (next.xPct - previous.xPct) / 6;
    const c1y = current.yPct + (next.yPct - previous.yPct) / 6;
    const c2x = next.xPct - (after.xPct - current.xPct) / 6;
    const c2y = next.yPct - (after.yPct - current.yPct) / 6;

    parts.push(
      `C ${fmt(c1x)} ${fmt(c1y)} ${fmt(c2x)} ${fmt(c2y)} ${fmt(next.xPct)} ${fmt(next.yPct)}`,
    );
  }
  return parts.join(' ');
}
